import { Button, FlexBox, InputText } from '@dixa/lib-shared-habla';
import { useInteractions } from '@floating-ui/react';
import { UploadMenu } from 'articleEditor/components/uploadMenu';
import { FloatingProps } from 'articleEditor/hooks/hoverUtils';
import { focusEditor } from 'lib-knowledge-document-structure/plate/common';
import { useMyEditorRef } from 'lib-knowledge-document-structure/plateHooks';
import { MyVideoEmbedElement } from 'lib-knowledge-document-structure/plateTypes';
import {
  embedVideo,
  getValidVideoProvider,
} from 'lib-knowledge-document-structure/plugins/createVideoEmbedPlugin/index';
import { useState } from 'react';

type UploadMenuProps = {
  element: MyVideoEmbedElement;
  floatingProps: FloatingProps;
  closeUploadMenu: () => void;
  getFloatingMenuProps: ReturnType<typeof useInteractions>['getFloatingProps'];
};

export function VideoPickerUploadMenu({
  element,
  floatingProps,
  closeUploadMenu,
  getFloatingMenuProps: getFloatingProps,
}: UploadMenuProps): JSX.Element {
  if (!floatingProps.isOpen) return <></>;

  return (
    <UploadMenu
      floatingProps={floatingProps}
      getFloatingProps={getFloatingProps}
    >
      <Embed element={element} closeUploadMenu={closeUploadMenu} />
    </UploadMenu>
  );
}

type EmbedProps = {
  element: MyVideoEmbedElement;
  closeUploadMenu: () => void;
};

function Embed({ closeUploadMenu, element }: EmbedProps) {
  const [videoUrl, setVideoUrl] = useState(element.url ?? '');
  const isValid = !!getValidVideoProvider(videoUrl);
  const editor = useMyEditorRef();

  const onEmbedVideo = () => {
    embedVideo({ editor, url: videoUrl, element });
    // Give the DOM a chance to update
    setTimeout(() => {
      closeUploadMenu();

      focusEditor(editor, editor.selection!);
    }, 50);
  };

  return (
    <FlexBox gap="200" padding="400" alignItems="center">
      <InputText
        placeholder="Video url"
        value={videoUrl}
        onChange={(e) => setVideoUrl(e.target.value)}
      />

      <Button
        disabled={!isValid}
        onClick={onEmbedVideo}
        style={{ height: '40px' }}
      >
        Embed
      </Button>
    </FlexBox>
  );
}
